import { createRouter, createWebHistory ,createWebHashHistory } from 'vue-router'
import routes  from './routes'
import guards from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

guards(router)

export default router
